"use client";

import { CancelFeedbackSurveyModalContent } from "./CancelFeedbackSurveyModalContent";
import { EdgenModalCreateAble } from "@components/EdgenModal";

/**
 * 打开「取消原因反馈」弹窗（EdgenModalCreateAble）
 */
export const openCancelFeedbackSurveyModal = () => {
  return new Promise<{ action: "close" | "submit" }>((resolve) => {
    const modalInstance = EdgenModalCreateAble.call({
      destroyOnClose: true,
      className: "",
      closeStyle: {
        right: 0,
        top: 0,
      },
      showClose: false,
      contentStyle: {
        padding: 0,
        overflow: "hidden",
      },
      containerStyle: {
        "--container-max-height": "calc(100vh - 60px)",
      },
      children: (
        <CancelFeedbackSurveyModalContent
          onClose={() => {
            EdgenModalCreateAble.end(modalInstance, false);
            resolve({ action: "close" });
          }}
          onSubmit={() => {
            EdgenModalCreateAble.end(modalInstance, false);
            resolve({ action: "submit" });
          }}
        />
      ),
    });
  });
};
